<div class="container home-container">
    <div class="row">
        <div class="col-md-6 py-4">
            <br>
            <h1 class="div-title-1">Observatorio Nacional de Prospectiva</h1>
            <section style="text-align: justify;">
                El Observatorio Nacional de Prospectiva es la plataforma de <b>información</b> sobre
                <b>tendencias</b>, <b>escenarios</b>, <b>riesgos</b>, <b>oportunidades</b> y <b>eventos de futuro</b>,
                sistematizada para el uso, consulta y aportes de los planificadores del país y del público en general.
            </section>
            <br>
            <section style="text-align: justify;">
                El Observatorio <b>se actualiza constantemente</b> para brindar información clave para la <b>toma de
                    decisiones con perspectiva de futuro</b> y visión de largo plazo. Su aplicación directa es en la
                <b>elaboración de políticas y planes</b> a todo nivel, puesto que presenta contenidos de interés de
                escala internacional, nacional y subnacional.
            </section>
        </div>
        <div class="col-md-6 py-4 iframe-video">
            <!-- <app-video-loading *ngIf="!isIframeReady"></app-video-loading> -->
            <div class="embed-responsive ratio ratio-16x9" [hidden]="!isIframeReady">
                <iframe class="embed-responsive-item" height="280"
                    src="https://www.youtube.com/embed/9P872x6ZdXU?controls=2&color=white&modestbranding=0"
                    title="Tutorial del Observatorio Nacional de Prospectiva" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen (load)="onIframeLoad()">
                </iframe>
            </div>

        </div>
        <br>
        <div class="col-sm-12 home-windows text-center">
            <!-- <h3 class="div-title-1">¿Qué estas buscando?</h3> -->
            <h3 class="div-title-search">¿Qué te gustaría descubrir?</h3>
            <app-search-bar></app-search-bar>
        </div>
        <div class="col-sm-12 home-windows">
            <div class="row text-white">
                <div class="col-sm-6 col-md-4 col-lg-4 pb-3" *ngFor="let o of events">
                    <div class="img-home-back img-border" [ngStyle]="{'background-image': 'url('+ o.img +')'}">
                        <div class="topdata-back" [ngClass]="o.class" routerLink="{{o.route}}">
                            <div class="topdata-title">
                                <a class="a-home-evt" routerLink="{{o.route}}">
                                    <i class="fa fa-stop fa-rotate-45"></i>
                                    <span style="padding-left: 1rem;">{{o.name}}</span>
                                </a>
                            </div>
                            <div class="topdata-cont"><b>{{o.summary}}</b>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <br>
    <div class="row pb-3">
        <div class="col-sm-6">
            <div class="div-news col-12">
                <i class="icon-news fa fa-globe"></i>
                <span>Actualidad</span>
            </div>
            <div *ngIf="n!=null && c_n.length>0">
                <div class="img-home-back img-border-top" [ngStyle]="{'background-image': 'url('+URL + n[0].img + ')'}"
                    routerLink="../actualidad/{{n[0].id}}" style="cursor: pointer;"></div>
                <div class="title-news">{{ n[0].title }}</div>
                <div class="date-news">{{ n[0].date | date:'mediumDate'}}</div>
                <div class="content-news" [innerHTML]="c_n[0].content"></div>
                <div class="more-news">
                    <a class="underline" routerLink="../actualidad/{{n[0].id}}">Leer más</a>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="div-news col-12">
                <i class="icon-news fa fa-comments-o"></i>
                <span>Encuentros prospectivos</span>
            </div>
            <div *ngIf="e!=null && c_e.length>0">
                <div class="img-home-back img-border-top" [ngStyle]="{'background-image': 'url('+URL + e[0].img + ')'}"
                    routerLink="../encuentro/{{e[0].id}}" style="cursor: pointer;"></div>
                <div class="title-news">{{ e[0].title }}</div>
                <div class="date-news pl-3">{{ e[0].date | date:'mediumDate'}}</div>
                <div class="content-news" [innerHTML]="c_e[0].content"></div>
                <div class="more-news">
                    <a class="underline" routerLink="../encuentro/{{e[0].id}}">Leer más</a>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="div-news col-12 position-relative">
                <i class="fa fa-bullhorn" aria-hidden="true"></i>
                <span>Publicaciones</span>
                <app-suscription></app-suscription>
            </div>
            <app-carousel-home-pubs></app-carousel-home-pubs>
        </div>
    </div>

</div>